import { MarketLayoutStylesSchema } from './MarketLayout.styles';

export const matchDetailsStyles: MarketLayoutStylesSchema = {
  headerText: {
    flex: '1',
    color: 'gamma.200',
    align: 'center',
    fontSize: '2xs',
    fontWeight: 'bold',
  },
  rowWrapper: {
    mx: '0.5',
    px: '4',
    py: '2',
    alignItems: 'center',
    display: 'flex',
    fontSize: 'xs',
    fontWeight: 'bold',
    justifyContent: 'space-between',
    borderColor: 'transparent',
    borderTopWidth: undefined,
    gap: '2',
    pos: 'relative',
    color: 'gamma.200',
    _before: {
      borderColor: 'blackAlpha.400',
      borderBottomWidth: '1px',
      boxShadow: '0 1px rgba(255, 255, 255, .07)',
      content: '""',
      w: 'full',
      left: '0',
      pos: 'absolute',
      top: '-1px',
    },
  },
  rowWrapperFirst: {
    borderTopWidth: '1px',
    overflowX: 'auto',
    _before: {
      display: 'none',
    },

    sx: {
      button: {
        px: 2,
        lineHeight: 'normal',
      },
    },
  },
  rowWrapperWithBtn: {
    borderColor: 'alpha.700',
    borderTopWidth: '1px',
  },
  tab: {
    bg: 'gamma.600',
    color: 'alpha.700',
    fontSize: '2xs',
    fontWeight: 'extrabold',
    _first: { ml: '4px' },
    _last: { mr: '4px' },
    _notFirst: { borderLeftWidth: '1px', borderLeftColor: 'alpha.700' },
    _selected: {
      bg: 'alpha.700',
      borderBottomColor: 'transparent',
      color: 'gamma.500',
    },
  },
};
